import { CSSObject } from '@emotion/react'
import { AssetReference } from '@opallabs/cassini'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import getAssetOrientation from '../../../../helpers/functions/getAssetOrientation'
import { sharedColors } from '../../../sharedDisplays/sharedStyles/styles'

const contentWrapper: CSSObject = {
  margin: '10px 10px 0 10px',
}

const linkAssetHeight: Record<string, string> = {
  mobileSingle: '180px',
  desktopSingle: '299px',
}

/* Styling for content */
const getContentWrapper = (isMobile: boolean): CSSObject => ({
  width: 'auto',
  margin: isMobile ? '7px 7px 0 7px' : '7px 7px 0 7px',
  fontSize: '15px',
  fontWeight: 500,
  lineHeight: '18px',
})

const getLinkAssetStyle = (hasAsset: boolean, display: string): CSSObject => ({
  border: sharedColors.linkBorder,
  borderBottom: 'none',
  borderRadius: display.includes('mobile') ? '8px 8px 0 0' : '8px 8px 0 0',
  height: hasAsset ? linkAssetHeight[display] : 0,
  width: display.includes('mobile') ? '410px' : '410px',
  img: {
    height: linkAssetHeight[display],
  },
})

const linkTitleStyle: CSSObject = {
  color: sharedColors.darkGreyText,
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.large,
  fontWeight: fontWeights.medium,
  padding: '2.5px 5px',
}

const getLinkDescriptionStyle = (isMobile: boolean): CSSObject => ({
  color: isMobile ? sharedColors.darkGreyText : sharedColors.medGreyText,
  fontFamily: fonts.helvetica,
  fontSize: isMobile ? fontSizes.medium : fontSizes.large,
  padding: '2.5px 5px',
})

const getLinkDomainStyle = (isMobile: boolean): CSSObject => ({
  color: sharedColors.medGreyText,
  fontSize: isMobile ? fontSizes.medium : fontSizes.large,
  padding: '2.5px 5px',
  fontFamily: fonts.helvetica,
})

const linkBorders: Record<string, string> = {
  mobileSingle: '8px',
  desktopSingle: '8px',
}

const getLinkStyle = (hasAsset: boolean, display: string): CSSObject => ({
  border: sharedColors.linkBorder,
  borderRadius: hasAsset
    ? `0 0 ${linkBorders[display]} ${linkBorders[display]}`
    : `${linkBorders[display]}`,
  borderTop: 'none',
  padding: display.includes('mobile') ? '10px' : '10px',
  '.kuiper-input-textarea .kuiper-input-container, kuiper-input-textarea.kuiper-filled kuiper-input-container':
    {
      backgroundColor: 'white',
    },
  '.kuiper-input.kuiper-filled .kuiper-input-container, .kuiper-input.kuiper-focused .kuiper-input-container':
    {
      backgroundColor: 'white',
    },
  '.kuiper-icon-wrapper .kuiper-icon-twitter-desktop-website-card-url': {
    color: sharedColors.medGreyText,
  },
})

const galleryDimensions: Record<string, CSSObject> = {
  desktopSingle: {
    height: '307px',
    width: '410px',
  },
  mobileSingle: {
    width: '410px',
  },
}

const getGalleryContainer = (display: string): CSSObject => ({
  ...galleryDimensions[display],
  overflow: 'auto',

  '> div': {
    columnGap: '8px',
    position: 'relative',
  },
  '.kuiper-asset': {
    backgroundColor: 'white',
    'img,video': {
      borderRadius: display.includes('mobile') ? '8px' : '8px',
      height: '100%',
      objectFit: 'cover',
      width: '100%',
    },
  },
})

const getAssetStyles = (
  asset: AssetReference,
  isMobile: boolean
): { asset: CSSObject; assetBase: CSSObject } => {
  const orientation = getAssetOrientation(asset)
  const maxWidth = isMobile ? '410px' : '410px'
  const maxHeight = isMobile ? '307px' : '307px'
  return {
    assetBase: {
      overflow: 'hidden',
      border: sharedColors.border,
      width: 'fit-content',
    },
    asset: {
      backgroundColor: 'white',
      width: orientation === 'portrait' ? 'auto' : maxWidth,
      height: orientation === 'landscape' ? 'auto' : maxHeight,
      maxWidth: orientation === 'portrait' ? maxWidth : '',
      'img,video': {
        borderRadius: isMobile ? '8px' : '8px',
        width: orientation !== 'portrait' ? maxWidth : '',
        height: orientation !== 'landscape' ? maxHeight : '',
        marginBottom: '-2px',
      },
    },
  }
}

const styles = {
  contentWrapper,
  linkTitleStyle,
  getContentWrapper,
  getGalleryContainer,
  getAssetStyles,
  getLinkAssetStyle,
  getLinkStyle,
  getLinkDescriptionStyle,
  getLinkDomainStyle,
}

export { styles }
